<!-- This Component has been deprecated in favor of Vue.toasted -->
<template>
  <div class="notifications">
    <v-snackbar
      v-for="notification in notifications"
      :key="notification.id"
      :value="notification"
      :timeout="notification.timeout"
      :color="colorFor(notification.type).bg"
      top
      @input="$emit('close', notification.id)"
    >
      <v-icon v-if="notification.icon">
        {{ notification.icon }}
      </v-icon>
      {{ notification.text }}
      <v-btn
        :color="colorFor(notification.type).fg"
        text
        @click="$emit('close', notification.id)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  methods: {
    colorFor(type) {
      const map = {
        info: { bg: 'primary', fg: 'white' },
        error: { bg: 'red', fg: 'white' },
        success: { bg: 'green', fg: 'white' },
      };
      return map[type] || map.info;
    },
  },
};
</script>

<style lang="stylus" scoped>
.notifications /deep/ .v-snack__wrapper {
  margin-top: 60px;
}

@media screen and (min-width: 959px) {
  .notifications /deep/ .v-snack__wrapper {
    margin-top: 76px;
  }
}
</style>
